import { getFirestore, collection, doc, getDocs, query, where } from "firebase/firestore";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

export default {
    state:{
        maxProDevicesList: []
    },
    mutations:{
        SET_MAX_PRO_DEVICES_LIST(state, maxProDevicesList){
            state.maxProDevicesList = maxProDevicesList
        }
    },
    actions:{
        GetUserMaxProDevices({ }, uid){
            return new Promise(async (resolve, reject) => {
                try {
                    const userReference = doc(db, "users", uid);
                    const reference = collection(db, "deviceCableCalculator")
                    const querySnapshot = await getDocs(query(reference, where('users', 'array-contains', userReference)))
                    const maxProDevices = []
                    querySnapshot.forEach((doc) =>  {
                        maxProDevices.push(doc.data())
                    })
                    resolve(maxProDevices)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetMaxProDevicesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "deviceCableCalculator"))
                    const maxProDevicesList = []
                    querySnapshot.forEach((doc) =>  {
                        maxProDevicesList.push(doc.data())
                    })
                    commit('SET_MAX_PRO_DEVICES_LIST', maxProDevicesList)
                    resolve(maxProDevicesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
    },
    getters:{
        getAllMaxProDevices(state){
            return state.maxProDevicesList;
        }
    }
}